module.exports = __webpack_public_path__ + "img/yb8.ad22ae90.jpg";